import { createProfile } from "./createProfile";
import { createProfileParameterSuggestion } from "./createProfileParameterSuggestion";
import { getAllAccountLinks } from "./getAllAccountLinks";
import { getKeycloakImportUsers } from "./getKeycloakImportUsers";
import { getConcernNames } from "./getConcernNames";
import { getCvp2ActiveConcerns } from "./getCvp2ActiveConcerns";
import { getIdentityProviderUserInfoOverrides } from "./getIdentityProviderUserInfoOverrides";
import { getCvPortalCandidateTokenForCurrentUser } from "./getCvPortalCandidateTokenForCurrentUser";
import { impersonationLogin } from "./impersonationLogin";
import { login } from "./login";
import { me } from "./me";
import { myVerifiedProfiles } from "./myVerifiedProfiles"; 
import { saveIdentityProviderUserInfoOverrides } from "./saveIdentityProviderUserInfoOverrides";
import { saveLocaleChoice } from "./saveLocaleChoice";
import { sendAttachProfileEmail } from "./sendAttachProfileEmail";
import { sendOtc } from "./sendOtc";
import { sendPhoneOtc } from "./sendPhoneOtc";
import { markEmailVerified } from "./markEmailVerified";
import { markPhoneVerified } from "./markPhoneVerified";
import { removeEmailVerification } from "./removeEmailVerification";
import { attachExistingCandidatesByVerifiedEmail } from "./attachExistingCandidatesByVerifiedEmail";
import { getVerifiedEmails } from "./getVerifiedEmails";
import { getVerifiedPhones } from "./getVerifiedPhones";
import { hasValidOtc } from "./hasValidOtc";
import { hasValidPhoneOtc } from "./hasValidPhoneOtc";
import { setActiveProfile } from "./setActiveProfile";
import { profileTimesheetsInConcern } from "./profileTimesheetsInConcern";
import { whoAmI } from "./whoAmI";

export const authAPI = {
  getCvPortalCandidateTokenForCurrentUser,
  login,
  whoAmI,
  me,
  sendAttachProfileEmail,
  sendOtc,
  sendPhoneOtc,
  markEmailVerified,
  markPhoneVerified,
  removeEmailVerification,
  attachExistingCandidatesByVerifiedEmail,
  getVerifiedEmails,
  getVerifiedPhones,
  hasValidOtc,
  hasValidPhoneOtc,
  createProfile,
  createProfileParameterSuggestion,
  myVerifiedProfiles,
  saveLocaleChoice,
  getConcernNames,
  getCvp2ActiveConcerns,
  impersonationLogin,
  getAllAccountLinks,
  getKeycloakImportUsers,
  getIdentityProviderUserInfoOverrides,
  saveIdentityProviderUserInfoOverrides,
  setActiveProfile,
  profileTimesheetsInConcern,
};

export type AuthAPI = typeof authAPI;
